import './index.css'

interface FormSectionProps {
    children: React.ReactNode;

}

const FormSection: React.FC<FormSectionProps> = ({ children }) => {
    return <div className="form-section">
        {children}
    </div>
}

interface FormElementProps {
    children: React.ReactNode;

}

const FormElement: React.FC<FormElementProps> = ({ children }) => {
    return <div className="form-element">
        {children}
    </div>
}

interface FormConfirmProps {
    children: React.ReactNode;

}

const FormConfirm: React.FC<FormConfirmProps> = ({ children }) => {
    return <div className="form-confirm">
        {children}
    </div>
}

export default FormSection;

export { FormElement, FormConfirm };